import {
  Button,
  Chip,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Stack,
  Typography,
} from '@mui/material'
import React, { useContext, useState } from 'react'
import moment from 'moment'
import StatusChip from './StatusChip'
import BigModal from '../../../components/Modals/BigModal'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import DuplicateEvent from './DuplicateEvent'
import LogsComponent from '../../../components/Logs/LogsComponent'
import { EventMetaContext } from './SingleEvent'
import EditIcon from '@mui/icons-material/Edit'
import EventIcon from '@mui/icons-material/Event'
import PlaceIcon from '@mui/icons-material/Place'
import { displayEventLocation } from '../../../helpers/eventAddress'
import EventExposureChip from '../../registration/components/EventExposureChip'

const TopPanel = () => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)
  const [openDuplicatePopup, setOpenDuplicatePopup] = useState(false)
  const [openActivityLog, setOpenActivityLog] = useState(false)
  const { setEditMode, eventMeta, loadEvent } = useContext(EventMetaContext)
  return (
    <Grid item xs={12}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 1.5, md: 2 },
          borderRadius: 3,
          border: '1px solid rgba(15, 23, 42, 0.08)',
          boxShadow: '0 8px 24px rgba(15, 23, 42, 0.05)',
        }}
      >
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          gap={1.5}
        >
          <Stack gap={1}>
            <Stack direction="row" gap={1} flexWrap="wrap" alignItems="center">
              <StatusChip compact />
              {eventMeta.EMPApproved && (
                <Chip size="small" color="success" label="EMP approved" />
              )}
              {eventMeta.empNotRequired && (
                <Chip size="small" color="default" label="EMP not required" />
              )}
              <EventExposureChip eventID={eventMeta._id} />
            </Stack>
            <Typography variant="h5" sx={{ fontWeight: 800 }}>
              {eventMeta.title}
            </Typography>
            <Stack direction="row" gap={2} flexWrap="wrap">
              <Stack direction="row" gap={0.75} alignItems="center">
                <EventIcon color="primary" fontSize="small" />
                <Typography variant="body2" color="text.secondary">
                  {moment(eventMeta.startDate).format('Do MMM YYYY HH:mm')} -{' '}
                  {moment(eventMeta.endDate).format('Do MMM YYYY HH:mm')}
                </Typography>
              </Stack>
              {displayEventLocation(eventMeta) && (
                <Stack direction="row" gap={0.75} alignItems="center">
                  <PlaceIcon color="primary" fontSize="small" />
                  <Typography variant="body2" color="text.secondary">
                    {displayEventLocation(eventMeta)}
                  </Typography>
                </Stack>
              )}
            </Stack>
          </Stack>
          <Stack direction="row" gap={1} alignItems="center">
            <Button
              variant="contained"
              color="anBlue"
              startIcon={<EditIcon />}
              onClick={() => setEditMode(true)}
            >
              Edit Event
            </Button>
            <IconButton onClick={(e) => setMenuAnchorEl(e.currentTarget)}>
              <MoreVertIcon size="small" color="primary" />
            </IconButton>
          </Stack>
        </Stack>
        <Menu
          open={!!menuAnchorEl}
          onClose={() => setMenuAnchorEl(null)}
          anchorEl={menuAnchorEl}
        >
          <MenuItem onClick={() => setEditMode(true)}>Edit Event Info</MenuItem>
          <MenuItem onClick={() => setOpenDuplicatePopup(true)}>
            Duplicate Event
          </MenuItem>
          <MenuItem
            onClick={() => {
              setMenuAnchorEl(null)
              setOpenActivityLog(true)
            }}
          >
            Activity Log
          </MenuItem>
        </Menu>
        <BigModal
          open={openActivityLog}
          onClose={() => setOpenActivityLog(false)}
        >
          {openActivityLog && (
            <Stack gap={1}>
              <Typography variant="title3">Activity Log</Typography>
              <LogsComponent
                hideTitle
                targetType="event"
                targetId={eventMeta._id}
              />
            </Stack>
          )}
        </BigModal>
        <BigModal
          open={openDuplicatePopup}
          onClose={() => setOpenDuplicatePopup(false)}
        >
          <DuplicateEvent
            onClose={() => {
              setOpenDuplicatePopup(false)
              loadEvent()
            }}
          />
        </BigModal>
      </Paper>
    </Grid>
  )
}

export default React.memo(TopPanel)
